// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:39:27

export default {
  "id": "mine-jump-1",
  "slug": "mine-jump-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/641735c649d8482a95fdde8c7790dd98-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/641735c649d8482a95fdde8c7790dd98/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mine Jump",
      "description": "Jump into action! ? Test your logic and reflexes in this addictive game. Collect slugs, upgrade your hero, and uncover the secrets of a mysterious planet! ?✨",
      "instructions": "Jump, jump, jump! A challenging reaction and logic game that won't let you get bored! Collect slugs, pump up your hero and find the edge of this planet!\n\nClick on the left or right side of the screen to move diagonally on a cell. If you make a mistake, you can go back. Get as far as you can to find out all the secrets of this mysterious planet!",
      "genres": [
        "Adventure"
      ],
      "tags": [
        "jumping",
        "minecraft",
        "parkour",
        "runner"
      ]
    },
    "zh-CN": {
      "title": "矿跳",
      "description": "跳入行动！在这个令人上瘾的游戏中测试你的逻辑和反应速度。收集蛞蝓，升级你的英雄，揭开神秘星球的秘密！✨",
      "instructions": "跳，跳，跳！一款充满挑战的反应与逻辑游戏，让你欲罢不能！收集鼻涕虫，增强你的英雄，探索这个星球的边界！\n\n点击屏幕左侧或右侧以在单元格上斜向移动。如果你出错，可以返回。尽可能远地前进，发现这个神秘星球的全部秘密！",
      "genres": [
        "冒险"
      ],
      "tags": [
        "跳跃",
        "我的世界",
        "跑酷",
        "竞速跑者"
      ]
    },
    "zh-TW": {
      "title": "礦洞跳躍",
      "description": "跳入行動！？在這款上癮遊戲中測試你的邏輯和反應能力。收集蚯蚓，升級你的英雄，並揭開神秘星球的秘密！？✨",
      "instructions": "跳，跳，跳！一場挑戰反應與邏輯的遊戲，讓你無法感到無聊！收集蚯蚓，提升你的英雄，尋找這個星球的邊緣！\n\n點擊螢幕的左邊或右邊來在單元內斜向移動。如果你犯了錯誤，你可以回頭。盡可能地前進，發現這個神秘星球的全部秘密！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "跳躍",
        "我的世界",
        "極限挑戰",
        "奔跑者"
      ]
    },
    "zh-HK": {
      "title": "礦坑跳躍",
      "description": "跳進行動！? 檢試你的邏輯和反應速度，在這款上癮遊戲中。收集蟾蜍，升級你的英雄，揭開神秘行星的謎團！？✨",
      "instructions": "跳，跳，跳！一個挑戰反應和邏輯的遊戲，讓你無法感到無聊！收集蚯蚓，提升你的英雄，尋找這個星球的邊緣！\n\n點擊螢幕的左或右邊，可以在一個單元內斜向移動。如果你犯了錯誤，你可以回頭。盡可能地走遠，發現這個神秘星球的全部秘密！",
      "genres": [
        "冒險"
      ],
      "tags": [
        "跳躍",
        "Minecraft",
        "潛行",
        "跑酷"
      ]
    },
    "ja": {
      "title": "マインジンプ",
      "description": "アクションに入ろう！この魅力的なゲームであなたの論理と反応を試してみましょう。タコを集め、ヒーローをアップグレードし、不思議な惑星の秘密を解き明かしてみましょう！✨",
      "instructions": "ジャンプ、ジャンプ、ジャンプ！退屈させない挑戦的な反応と論理ゲーム！カタツムリを集め、ヒーローを力付けて、この惑星の端を見つけ出せ！\n\nスクリーンの左側か右側をクリックして、セル内で斜めに動く。間違えたら戻れるよ。この神秘的な惑星のすべての秘密を見つけるために、できるだけ遠くまで行こう！",
      "genres": [
        "アドベンチャー"
      ],
      "tags": [
        "ジャンプ",
        "マインクラフト",
        "パークアウト",
        "ランナー"
      ]
    },
    "ko": {
      "title": "불사탐험",
      "description": "작동에 뛰어들어라! 이 흥미진진한 게임에서 논리와 반응 속도를 테스트해 보세요. 달팽이를 수집하고 영웅을 업그레이드하고 음모적인 행성의 비밀을 밝혀보세요! ✨",
      "instructions": "점프, 점프, 점프! 지루해질 수 없는 도전적인 반응과 논리 게임! 달팽이를 모으고, 주인공을 강화하고, 이 행성의 경계를 찾아보세요!\n\n화면 왼쪽 또는 오른쪽을 클릭하여 세포에서 대각선으로 이동하세요. 실수를 했을 때는 되돌릴 수 있습니다. 모든 비밀을 찾기 위해 가장 멀리 갈 수 있도록 노력하세요!",
      "genres": [
        "모험"
      ],
      "tags": [
        "점프",
        "마인크래프트",
        "파크로",
        "러너"
      ]
    },
    "fr": {
      "title": "Saut de Mine",
      "description": "Sauter dans l'action ! ?Testez votre logique et vos réflexes dans ce jeu accrocheur. Ramassez des escargots, améliorez votre héros et découvrez les secrets d'une planète mystérieuse ! ?✨",
      "instructions": "Saut, saute, saute ! Un jeu de réaction et de logique défiant qui ne vous laisserez pas ennuyer ! Collectez des escargots, gonflez votre héros et trouvez le bord de cette planète !\n\nCliquez sur le côté gauche ou droit de l'écran pour vous déplacer diagonalement sur une cellule. Si vous faites une erreur, vous pouvez revenir en arrière. Allez le plus loin possible pour découvrir tous les secrets de cette planète mystérieuse !",
      "genres": [
        "Aventure"
      ],
      "tags": [
        "saut",
        "Minecraft",
        "parkour",
        "coureur"
      ]
    }
  }
};
